import React from 'react';
import styles from './Header.module.scss'
import Navigation from "../Navigation/navigation";


const Header = (props) => {
    return (
        <div className={styles.header}>
            <Navigation/>
        </div>
    );
};

export default Header;